import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { VenueService } from "../../../../services/venues/venue.service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-delete-division',
  templateUrl: './delete-division.component.html',
  styleUrls: ['./delete-division.component.scss']
})
export class DeleteDivisionComponent implements OnInit {

  //#region Fields
  public divisionId: string;
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private venueService: VenueService,
    private messageService: MessageService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.divisionId = this.config.data.id;
    }
  }

  public ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  public deleteDivision(divisionId: string): void {
    this.spinner = true;
    this.venueService.deleteDivision(divisionId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: _ => {
          this.ref.close(true)
        },
        error: _ => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
